import { lazy } from 'react';

// Registro de componentessponibles en el sistema
const REGISTRO_COMPONENTES = {
    // Rutas principales
    '/dashboard': lazy(() => import('../paginas/menu/dashboard')),
    '/menus': lazy(() => import('../paginas/menu/menu')),
    '/importexport': lazy(() => import('../utils/importadorExportador')),
    '/perfil': lazy(() => import('../paginas/perfil/perfil')),
    
    // Parámetros - Generales
    '/tipocomplementoproducto': lazy(() => import('../paginas/tipocomplementoProducto/tipoComplementoProducto')),
    '/complementoproducto': lazy(() => import('../paginas/complementoProducto/complementoProducto')),
    '/geografiapolitica': lazy(() => import('../paginas/geografiaPolitica/geografiaPolitica')),
    '/tipodocumentoidentidad': lazy(() => import('../paginas/tipoDocumentoIdentidad/tipoDocumentoIdentidad')),
    '/preferencias': lazy(() => import('../paginas/preferencias/index')),
    '/zona': lazy(() => import('../paginas/zona/zona')),
    '/personas': lazy(() => import('../paginas/personas/personas')),
    '/tiposcliente': lazy(() => import('../paginas/tiposCliente/tiposCliente')),
    
    // Parámetros - Inventarios
    '/curvacomplementos': lazy(() => import('../paginas/curvaComplementos/curvaComplementos')),
    '/unidadesmedida': lazy(() => import('../paginas/unidadesMedida/unidadesMedida')),
    '/productosTipo': lazy(() => import('../paginas/productosTipo/productosTipo')),
    '/almacenes': lazy(() => import('../paginas/almacenes/almacenes')),
    '/tiposentradasalida': lazy(() => import('../paginas/tiposEntradaSalida/tiposEntradaSalida')),
    '/grupocualidades': lazy(() => import('../paginas/grupoCualidades/grupoCualidades')),
    '/tiposcualidad': lazy(() => import('../paginas/tiposCualidad/tiposCualidad')),
    '/grupos': lazy(() => import('../paginas/grupos/grupos')),
    '/tipogrupos': lazy(() => import('../paginas/tipoGrupos/tipoGrupos')),
    '/estructuragrupos': lazy(() => import('../paginas/estructuraGrupos/estructuraGrupos')),
    '/productos': lazy(() => import('../paginas/productos/productos')),
    '/encabezadotomafisica': lazy(() => import('../paginas/encabezadoTomaFisica/encabezadoTomaFisica')),
    '/movimientotomafisica': lazy(() => import('../paginas/movimientoTomaFisica/movimientoTomaFisica')),
    '/controlUnidadesTomafisica': lazy(() => import('../paginas/controlUnidadesTomaFisica/controlUnidadesTomaFisica')),
    '/paneladministraciontomafisica': lazy(() => import('../paginas/toma-fisica/PanelAdministracion')),
    '/paneladministracionproductos': lazy(() => import('../paginas/productos/PanelAdministracionProductos')),
    '/paneladministracionproductos/nuevo': lazy(() => import('../paginas/productos/PanelAdministracionProductos')),
    '/paneladministracionproductos/lista': lazy(() => import('../paginas/productos/PanelAdministracionProductos')),
    '/paneladministracionproductos/cargaimagenes': lazy(() => import('../paginas/productos/PanelAdministracionProductos')),
    '/paneladministracionproductos/masivas': lazy(() => import('../paginas/productos/PanelAdministracionProductos')),
    '/paneladministracionproductos/estadisticas': lazy(() => import('../paginas/productos/PanelAdministracionProductos')),
    '/paneladministracionproductos/importexport': lazy(() => import('../paginas/productos/PanelAdministracionProductos')),
    '/paneladministracionproductos/etiquetas': lazy(() => import('../paginas/productos/PanelAdministracionProductos')),
    '/paneladministracionproductos/complementos': lazy(() => import('../paginas/productos/PanelAdministracionProductos')),
    '/paneladministracionproductos/consulta': lazy(() => import('../paginas/productos/PanelAdministracionProductos')),

    // Parámetros - Contables
    '/sociedad': lazy(() => import('../paginas/sociedad/sociedad')),
    '/pagosformas': lazy(() => import('../paginas/pagosFormas/pagosFormas')),
    '/tienda': lazy(() => import('../paginas/tienda/tienda')),
    '/cajaspos': lazy(() => import('../paginas/cajasPos/cajasPos')),
    '/cajastiposmovimiento': lazy(() => import('../paginas/cajasTiposMovimiento/cajasTiposMovimiento')),
    '/usuarioscajas': lazy(() => import('../paginas/usuariosCajas/usuariosCajas')),
    '/tiposcomprobante': lazy(() => import('../paginas/tiposComprobante/tiposComprobante')),
    '/tasa': lazy(() => import('../paginas/tasa/tasa')),
    '/tiposdocumentocontable': lazy(() => import('../paginas/tiposDocumentoContable/tiposDocumentoContable')),
    '/resolucionesdian': lazy(() => import('../paginas/resolucionesDian/resolucionesDian.js')),
    
    // Sistema
    '/jobs': lazy(() => import('../paginas/jobs/jobs')),
    '/usuarios': lazy(() => import('../paginas/usuarios/usuario')),
    '/auditoria': lazy(() => import('../paginas/auditoria')),
    '/adminhyperiomconnect': lazy(() => import('../paginas/adminHyperiomConnect')),
    '/dbinfo': lazy(() => import('../paginas/dbinfo/DbInfoDashboard')),
    '/sistema/admin-rutas': lazy(() => import('../paginas/sistema/adminRutas')),
    '/sistema/estado': lazy(() => import('../paginas/sistema/estadoSistema')),
    '/aplicaciones-usuario': lazy(() => import('../paginas/aplicacionesUsuario/aplicacionesUsuario')),
    '/mis-aplicaciones': lazy(() => import('../paginas/aplicacionesUsuario/MisAplicaciones')),
    
    // Comercial
    '/tipoprecio': lazy(() => import('../paginas/tiposPrecio/tiposPrecio')),
    '/comparativofechas': lazy(() => import('../paginas/comparativoFechas/comparativoFechas')),
    '/semanascomerciales': lazy(() => import('../paginas/semanasComerciales/semanasComerciales')),
    '/diasfestivos': lazy(() => import('../paginas/diasFestivos/diasFestivos')),
    '/participacion-ppto-ventas': lazy(() => import('../participacionppto/tablaParticipacion')),
    '/participacion-ppto-compras': lazy(() => import('../participacionppto/TablaParticipacionCompras')),
    
    '/distribucion-ppto-ventas': lazy(() => import('../participacionppto/ppto')),
    '/distribucion-ppto-compras': lazy(() => import('../participacionppto/DistribucionPptoCompras')),
    '/consulta-reporte-compras': lazy(() => import('../participacionppto/ConsultaReporteCompras')),
    '/consulta-presupuesto-compras': lazy(() => import('../participacionppto/ConsultaPresupuestoCompras')),
    '/ppto-compras': lazy(() => import('../participacionppto/PptoCompras')),
    '/ppto-ventas': lazy(() => import('../participacionppto/pptoVentas')),
    '/consulta-cumple-ppto-ventas': lazy(() => import('../paginas/consultaSimpleCumplePptoVentas/ConsultaSimpleCumplePptoVentas')),
    '/resolucionesDian': lazy(() => import('../paginas/resolucionesDian/resolucionesDian')),
    
    // Compras
    '/productosreprogramables': lazy(() => import('../paginas/productosReprogramables/productosReprogramables')),
    '/coberturatiendas': lazy(() => import('../paginas/coberturaTiendas/coberturaTiendas')),
    '/productospuntoprecio': lazy(() => import('../paginas/productosPuntoPrecio/productosPuntoPrecio')),
    '/tipospuntoprecio': lazy(() => import('../paginas/tiposPuntoPrecio/tiposPuntoPrecio')),
    '/productosequivalentes': lazy(() => import('../paginas/productosEquivalentes/productosEquivalentes')),
    '/coberturasociedad': lazy(() => import('../paginas/coberturaSociedad/coberturaSociedad')),
    '/proveedoresmarca': lazy(() => import('../paginas/proveedoresMarca/proveedoresMarca')),
    '/marcas': lazy(() => import('../paginas/marcas/marcas')),
    
    // Interfaces
    '/interfaces': lazy(() => import('../interfaces/interfaces')),
    
    // Importaciones
    '/importaciones/complementos-productos': lazy(() => import('../paginas/importaciones/ImportarComplementosProductos')),
    '/importaciones/productos': lazy(() => import('../paginas/importaciones/ImportarProductos')),
    '/importaciones/productos-barras': lazy(() => import('../paginas/importaciones/ImportarProductosBarras')),
    '/importaciones/productos-precios': lazy(() => import('../paginas/importaciones/ImportarProductosPrecios')),
    '/importaciones/productos-imagenes': lazy(() => import('../paginas/importaciones/ImportarProductosImagenes')),
    '/importaciones/terceros': lazy(() => import('../paginas/importaciones/ImportarTerceros')),
    '/importaciones/ventas': lazy(() => import('../paginas/importaciones/ImportarVentas')),
    '/importaciones/compras': lazy(() => import('../paginas/importaciones/ImportarCompras')),
    '/importaciones/movimientos-contables': lazy(() => import('../paginas/importaciones/ImportarMovContable')),
    
    // Consultas
    '/consulta-existencias-siesa': lazy(() => import('../paginas/productos/ConsultaExistenciasSiesa')),
    
    // Rutas especiales (no administrables directamente pero pueden estar en menú)
    '/recuperarpassword': lazy(() => import('../paginas/usuarios/recuperarPassword')),
    '/resetpassword': lazy(() => import('../paginas/usuarios/resetPassword')),
    '/cambioclave': lazy(() => import('../paginas/usuarios/cambioClave')),
    '/documentos' : lazy(() => import('../documentos/listar')),
    '/reporte-documentos-dinamico': lazy(() => import('../documentos/ReporteDocumentosDinamico')),
    
    // BI Analytics — Inteligencia de Negocios
    '/bi-analytics': lazy(() => import('../paginas/biAnalytics/BIAnalytics')),

    // Administración — Consumo API IA (solo admin)
    '/admin-ia-consumo': lazy(() => import('../paginas/adminAiConsumo/AdminAiConsumo')),

    // Bitácora de Tiendas
    '/bitacora': lazy(() => import('../bitacora/BitacoraDashboard')),
    '/bitacora/parametrizacion': lazy(() => import('../bitacora/ParametrizacionDashboard')),

    // Integraciones
    '/integraciones/dian': lazy(() => import('../paginas/configuracionDian/ConfiguracionDian')),
    '/integraciones/dian/facturas': lazy(() => import('../paginas/facturasDian/facturasDian')),
    '/facturasdian': lazy(() => import('../paginas/facturasDian/facturasDian')),

};

/**
 * Obtiene el componente asociado a una URL
 * @param {string} url - La URL del componente
 * @returns {React.Component|null} - El componente lazy o null si no existe
 */
export function obtenerComponente(url) {
    return REGISTRO_COMPONENTES[url] || null;
}

/**
 * Verifica si un componente está disponible para una URL
 * @param {string} url - La URL a verificar
 * @returns {boolean} - true si el componente existe
 */
export function esComponenteDisponible(url) {
    return url in REGISTRO_COMPONENTES;
}

/**
 * Obtiene todas las rutas disponibles en el sistema
 * @returns {string[]} - Array con todas las URLs disponibles
 */
export function obtenerRutasDisponibles() {
    return Object.keys(REGISTRO_COMPONENTES);
}

/**
 * Obtiene rutas filtradas por categoría (basado en el path)
 * @param {string} categoria - Categoría a filtrar (ej: 'parametros', 'sistema')
 * @returns {string[]} - Array de URLs de la categoría
 */
export function obtenerRutasPorCategoria(categoria) {
    return Object.keys(REGISTRO_COMPONENTES).filter(url => 
	url.toLowerCase().includes(categoria.toLowerCase())
    );
}

/**
 * Registra un nuevo componente dinámicamente (para módulos adicionales)
 * @param {string} url - URL del componente
 * @param {React.Component} component - Componente lazy
 */
export function registrarComponente(url, component) {
    REGISTRO_COMPONENTES[url] = component;
}

/**
 * Obtiene estadísticas del registro
 * @returns {object} - Estadísticas del registro
 */
export function obtenerEstadisticas() {
    const rutas = Object.keys(REGISTRO_COMPONENTES);
    return {
	total: rutas.length,
	administrables: rutas.filter(url => 
	    !url.includes('recuperar') && 
		!url.includes('reset') && 
		!url.includes('cambioclave')
	).length,
	especiales: rutas.filter(url => 
	    url.includes('recuperar') || 
		url.includes('reset') || 
		url.includes('cambioclave')
	).length,
	categorias: {
	    parametros: rutas.filter(url => 
		url.includes('tipo') || 
		    url.includes('complemento') || 
		    url.includes('geografia') || 
		    url.includes('zona') || 
		    url.includes('persona')
	    ).length,
	    inventarios: rutas.filter(url => 
		url.includes('producto') || 
		    url.includes('grupo') || 
		    url.includes('almacen') || 
		    url.includes('unidad')
	    ).length,
	    contables: rutas.filter(url => 
		url.includes('sociedad') || 
		    url.includes('tienda') || 
		    url.includes('tasa') || 
		    url.includes('comprobante')
	    ).length,
	    sistema: rutas.filter(url => 
		url.includes('usuario') || 
		    url.includes('auditoria') || 
		    url.includes('admin') || 
		    url.includes('menu')
	    ).length
	}
    };
}

/**
 * Obtiene una lista formateada de todos los componentes registrados
 * @returns {Array} Lista de componentes con nombre y URL
 */
export function obtenerComponentesRegistrados() {
    return Object.keys(REGISTRO_COMPONENTES).map(url => {
	// Generar nombre amigable desde la URL
	const nombre = url.split('/').pop()
	      .replace(/-/g, ' ')
	      .split(' ')
	      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
	      .join(' ');
	
	return {
	    url,
	    nombre,
	    componente: REGISTRO_COMPONENTES[url]
	};
    }).sort((a, b) => a.nombre.localeCompare(b.nombre));
}

export { REGISTRO_COMPONENTES };
export default REGISTRO_COMPONENTES;
